import { Event, NavigationEnd } from '@angular/router'

export const isNavigationEndEvent = (input: Event): input is NavigationEnd =>
    input instanceof NavigationEnd
